import { render, staticRenderFns } from "./UIendGame.vue?vue&type=template&id=76842cf2&scoped=true&"
import script from "./UIendGame.vue?vue&type=script&lang=js&"
export * from "./UIendGame.vue?vue&type=script&lang=js&"
import style0 from "./UIendGame.vue?vue&type=style&index=0&id=76842cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76842cf2",
  null
  
)

export default component.exports